import React, { useEffect } from 'react';

import { Trans } from 'react-i18next';
import { P3Bold, P2Bold } from '../../../../../Common/DesignSystem/Text';
import colours from '../../../../../Common/DesignSystem/Colours';
import { DropdownItem, Input } from '../../../../../Common/DesignSystem/Input';
import FileUploadCard from '../../../../../Common/DesignSystem/FileUploadCard';

export const VehicleSpecsCard = ({ vehicleForm, updateVehicleForm, updateSelect, specType, selectSpecType, specName, specThumbnail, specInputRef, specDropRef, uploadSpecSheet, loadingSpec, vehicleOptions, vehicleOemDetails, editingVehicleSpecSheet, setSpecSheet }) => {

	useEffect(() => {
		if (editingVehicleSpecSheet) {
			setSpecSheet(editingVehicleSpecSheet);
		}
	}, [editingVehicleSpecSheet]);

	return (
		<div className="overlay_header_bordered" style={{flexGrow: 0}}>
			<div className="profile-info-container">
				<div style={{flexDirection: 'column', flex: 1, display: 'flex', width: '100%'}}>
					<P2Bold style={{padding: '8px 0px', color: colours.primary.grey01}}>
						Specifications
					</P2Bold>
					<div style={{display: 'inline-flex', flex: 1, alignItems: 'center'}}>
						<input
							type="radio"
							name="specsheet"
							value="upload-file"
							checked={specType === "FILE"}
							id="upload-file"
							onClick={() => selectSpecType('FILE')}
						/>
						<label htmlFor="upload-file"><Trans>File from computer</Trans></label>
						<input
							type="radio"
							name="specsheet"
							value="upload-link"
							checked={specType === "LINK"}
							id="from-link"
							onClick={() => selectSpecType('LINK')}
						/>
						<label htmlFor="from-link"><Trans>Link</Trans></label>
					</div>
					{specType == 'FILE' ? (
						<FileUploadCard
							imageSrc={specThumbnail || vehicleForm.spec_sheet || null}
							imageName={specName}
							uploadText="Add Spec Sheet or Drop Here"
							accept=".pdf, .doc, .docx"
							inputRef={specInputRef}
							dropRef={specDropRef}
							handleUpload={uploadSpecSheet}
							replaceClick={()=>{specInputRef.current.click()}}
							loading={loadingSpec}
						/>

					) : (
						<Input
							name="spec_sheet"
							placeholder="File URL"
							value={vehicleForm.spec_sheet}
							onChange={updateVehicleForm}
						/>
					)}
					<Input
						label={vehicleOptions.engine.name}
						dropdownLabel={vehicleOemDetails.engine_opt[vehicleForm.engine]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'engine', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.engine}
					>
						{vehicleOemDetails.engine_opt.map((engine_option, index) =>
							<DropdownItem label={engine_option} value={index}/>
						)}
					</Input>
					<Input
						label={vehicleOptions.drive_train.name}
						dropdownLabel={vehicleOemDetails.drive_train_opt[vehicleForm.drive_train]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'drive_train', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.drive_train}
					>
						{vehicleOemDetails.drive_train_opt.map((drive_train_option, index) =>
							<DropdownItem label={drive_train_option} value={index}/>
						)}
					</Input>
					<Input
						label={vehicleOptions.body_type.name}
						dropdownLabel={vehicleOemDetails.body_style_opt[vehicleForm.body_style]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'body_style', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.body_style}
					>
						{vehicleOemDetails.body_style_opt.map((body_style_option, index) =>
							<DropdownItem label={body_style_option} value={index}/>
						)}
					</Input>
					<Input
						label={vehicleOptions.transmission.name}
						dropdownLabel={vehicleOemDetails.trans_opt[vehicleForm.transmission]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'transmission', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.transmission}
					>
						{vehicleOemDetails.trans_opt.map((transmission_option, index) =>
							<DropdownItem label={transmission_option} value={index}/>
						)}
					</Input>
					<Input
						label={vehicleOptions.tires.name}
						dropdownLabel={vehicleOemDetails.tires_opt[vehicleForm.tires]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'tires', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.tires}
					>
						{vehicleOemDetails.tires_opt.map((tires_option, index) =>
							<DropdownItem label={tires_option} value={index}/>
						)}
					</Input>
					<Input
						label={vehicleOptions.roof.name}
						dropdownLabel={vehicleOemDetails.roof_opt[vehicleForm.roof]}
						dropdown
						onChange={(e)=> {updateSelect({name: 'roof', value: e.currentTarget.dataset.id})}}
						value={vehicleForm.roof}
					>
						{vehicleOemDetails.roof_opt.map((roof_option, index) =>
							<DropdownItem label={roof_option} value={index}/>
						)}
					</Input>
					<label style={{display: 'inline-flex'}}>
						<input type="checkbox" id="new_model_checkbox" checked={vehicleForm.is_new_model} name="is_new_model" onChange={updateVehicleForm}/>
						<span className="ds-input-dropdown-label"><P3Bold>New Model</P3Bold></span>
					</label>
					<label style={{display: 'inline-flex'}}>
						<input type="checkbox" id="prototype_checkbox" checked={vehicleForm.is_prototype} name="is_prototype" onChange={updateVehicleForm}/>
						<span className="ds-input-dropdown-label"><P3Bold>Prototype</P3Bold></span>
					</label>
					<label style={{display: 'inline-flex'}}>
						<input type="checkbox" id="redesign_checkbox" checked={vehicleForm.is_redesign} name="is_redesign" onChange={updateVehicleForm}/>
						<span className="ds-input-dropdown-label"><P3Bold>Redesign</P3Bold></span>
					</label>
				</div>
			</div>
		</div>
	)
}